import React, { useRef } from "react"
import { SelectField } from "../../forms"

const DropdownActionsCell = ({
  actionCellHandler,
  value,
  row: {
    original: { id }
  }
}) => {
  const ref = useRef(null)
  const onChange = (event) => {
    const action = event.target.value
    actionCellHandler(event, id, action)

    if (ref.current) {
      ref.current.value = ""
    }
  }

  const actionTexts = {
    view: "View",
    upload: "Upload",
    sign: "Sign",
    edit: "Edit",
    delete: "Delete",
    accept_interview: "Accept Interview",
    decline_interview: "Decline Interview",
    reschedule_interview: "Reschedule Interview",
    cancel_interview: "Cancel Interview",
    offer_placement: "Make Offer",
    decline_placement: "Decline",
    ammend: "Amend Offer",
    cancel_offer: "Cancel Offer",
    pdf: "PDF",
    csv: "CSV",
    submit: "Submit",
    filled: "Mark as Filled",
    unfulfilled: "Filled",
    search: "Search",
    reinvite: "Re-Invite",
    continue: "Continue",
    confirm: "Confirm",
    add_placement_midpoint_pay: "Add Placement Midpoint Net Pay",
    add_placement_end_date_pay: "Add Placement End Date Net Pay",
    edit_placement_midpoint_pay: "Edit Placement Midpoint Net Pay",
    edit_placement_end_date_pay: "Edit Placement End Date Net Pay"
  }

  const options = value.map((action) => [action, actionTexts[action]])

  return <SelectField onChange={onChange} ref={ref} options={options} blank="- Choose action -" tableRow={true} />
}

export default DropdownActionsCell
